import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import { formatUSD } from '@sparefoot/react-core/utils/format';
import { withShowHide } from '@sparefoot/react-core/decorators';

import { Alert } from 'components/core/Alert';
import { Button } from 'components/core/Button';
import { Image } from 'components/core/Image';
import { Paragraph } from 'components/core/Typography';

import plus from 'assets/images/facility/plus.svg';
import minus from 'assets/images/facility/minus.svg';

import './FeeWarningAlert.scss';

export const enhance = compose(
	withProps(({ facility }) => ({
		fees: [
			{
				name: 'One-Time Admin Fee',
				price: facility.adminFee,
			},
			{
				name: 'One-Time Lock Fee',
				price: facility.lockFee,
			},
		],
		totalFees: facility.totalFees,
		feeDetailsShowing: false,
	})),
	withShowHide('feeDetails'),
);

export function FeeWarningAlert({
	fees,
	totalFees,
	feeDetailsShowing,
	onToggleFeeDetails,
	unitPrice,
}) {
	return (
		<Alert
			type="warning"
			className="fee-alert"
		>
			<Paragraph
				weight="extraBold"
				last
			>
				{'The Following one time fees shall apply:'}
			</Paragraph>
			<ul>
				{fees.map(
					(fee) =>
						fee.price > 0 && (
							<li
								key={fee.name}
								className="fee-item"
							>
								<Paragraph last>
									{`${fee.name}: $${fee.price}`}
								</Paragraph>
							</li>
						),
				)}
			</ul>
			<Paragraph last>
				{`Your first month's bill will be ${formatUSD(totalFees + unitPrice)} plus taxes`}
			</Paragraph>
			<div className="show-more-fees">
				<Button
					link
					underline
					onClick={onToggleFeeDetails}
					className="fees-learn-more-button"
				>
					{feeDetailsShowing ? 'Close Details' : 'Read More'} About
					Admin Fees
				</Button>
				<Image
					src={feeDetailsShowing ? minus : plus}
					className="plus-icon"
				/>
			</div>
			{feeDetailsShowing && (
				<Paragraph last>
					{
						'The one-time, non-refundable admin fee is charged upon signing your lease agreement. This fee covers the costs associated with processing your application and setting up your account and access credentials, ensuring a smooth move-in process.'
					}
				</Paragraph>
			)}
		</Alert>
	);
}

FeeWarningAlert.propTypes = {
	fees: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			price: PropTypes.number,
		}),
	).isRequired,
	totalFees: PropTypes.number.isRequired,
	feeDetailsShowing: PropTypes.bool,
	onToggleFeeDetails: PropTypes.func,
	unitPrice: PropTypes.number,
};

export default enhance(FeeWarningAlert);
